import { AppLocale, DEFAULT_LOCALE, LOCALE_ROUTE_SEGMENTS } from './locale.constants';

export function localeFromRouteSegment(segment: string | null | undefined): AppLocale | null {
  if (!segment) {
    return null;
  }

  const normalizedSegment = segment.toLowerCase();
  const match = Object.entries(LOCALE_ROUTE_SEGMENTS).find(
    ([, routeSegment]) => routeSegment === normalizedSegment,
  );

  return (match?.[0] as AppLocale | undefined) ?? null;
}

export function routeSegmentForLocale(locale: AppLocale): string | null {
  return locale === DEFAULT_LOCALE ? null : LOCALE_ROUTE_SEGMENTS[locale];
}

export function stripLocaleRouteSegment(segments: string[]): string[] {
  return localeFromRouteSegment(segments[0]) ? segments.slice(1) : segments;
}

export function localizePath(path: string, locale: AppLocale): string {
  if (!path.startsWith('/')) {
    return path;
  }

  const [, pathname = '/', search = '', hash = ''] =
    path.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/) ?? [];
  const routeSegments = stripLocaleRouteSegment(pathname.split('/').filter(Boolean));
  const localeSegment = routeSegmentForLocale(locale);
  const localizedSegments = localeSegment ? [localeSegment, ...routeSegments] : routeSegments;
  const localizedPathname = `/${localizedSegments.join('/')}`;

  return `${localizedPathname}${search}${hash}`;
}
